import { BindAll } from 'lodash-decorators';
import React from 'react';

@BindAll()
export default class Loading extends React.Component {
  componentDidMount() {}
  render() {
    return (
      <span />
      // <div className="app-loading">
      //   <React.Antd.ProSkeleton />
      // </div>
    );
  }
}
